/**
 * Build identity of this Admin bundle, read from the Vite-injected `define` constants (vite.config.ts).
 *
 * Surfaced in Configurações › Sobre so the operator can confirm exactly which version is running and match it
 * against what was built/deployed. The `typeof` guards keep this safe if a consumer (e.g. a unit test) runs
 * without the `define` substitution — it degrades to `dev`/`unknown` instead of throwing a ReferenceError.
 */
export interface AdminBuildInfo {
  /** Release tag this bundle was built with (mirrors the deployed image tag), e.g. `0.5.2`. */
  readonly version: string;
  /** Short git SHA of the tree the bundle was built from, e.g. `ec5cece`. */
  readonly commit: string;
  /** ISO-8601 instant the bundle was compiled. */
  readonly builtAt: string;
}

export const ADMIN_BUILD: AdminBuildInfo = {
  version: typeof __VELLO_ADMIN_VERSION__ === 'string' ? __VELLO_ADMIN_VERSION__ : 'dev',
  commit: typeof __VELLO_ADMIN_COMMIT__ === 'string' ? __VELLO_ADMIN_COMMIT__ : 'unknown',
  builtAt: typeof __VELLO_BUILD_TIME__ === 'string' ? __VELLO_BUILD_TIME__ : '',
};
